// extracted by mini-css-extract-plugin
export default {"formContainer":"EditClient_formContainer__+6nOn","formField":"EditClient_formField__vKijv","btnsContainer":"EditClient_btnsContainer__7Z1E9"};